/* LZ Black November lender — otkrivanje pri skrolu, odbrojavanja i sticky traka za sekcije lz-bn-*.
   Svaka sekcija učitava ovaj fajl; izvršava se jednom, a ponovni poziv samo skenira nove elemente (theme editor). */
(() => {
  if (window.__lzbn) { window.__lzbn.scan(); return; }
  const root = document.documentElement;
  root.classList.add('lzbn-js');
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const reveal = (el) => {
    el.classList.add('is-in');
    if (el.classList.contains('lzbn-stagger')) setTimeout(() => el.classList.add('is-done'), 1200);
  };
  const io = ('IntersectionObserver' in window && !reduce)
    ? new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      }), { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })
    : null;

  const pad = (n) => String(n).padStart(2, '0');
  const setUnit = (el, val) => {
    if (!el || el.textContent === val) return;
    el.textContent = val;
    if (reduce) return;
    el.classList.remove('is-tick');
    void el.offsetWidth;
    el.classList.add('is-tick');
  };
  const tickCountdowns = () => {
    document.querySelectorAll('[data-lzbn-cd]').forEach((el) => {
      const end = Date.parse(el.dataset.deadline);
      if (isNaN(end)) return;
      const start = Date.parse(el.dataset.launch || '');
      const now = isNaN(start) ? Date.now() : Math.max(Date.now(), start);
      let s = Math.max(0, Math.floor((end - now) / 1000));
      const box = el.closest('[data-lzbn-cd-box]');
      if (box) box.classList.toggle('is-over', s === 0);
      const d = Math.floor(s / 86400); s %= 86400;
      const h = Math.floor(s / 3600); s %= 3600;
      const m = Math.floor(s / 60); s %= 60;
      setUnit(el.querySelector('[data-u="d"]'), String(d));
      setUnit(el.querySelector('[data-u="h"]'), pad(h));
      setUnit(el.querySelector('[data-u="m"]'), pad(m));
      setUnit(el.querySelector('[data-u="s"]'), pad(s));
    });
  };

  const stickies = () => document.querySelectorAll('[data-lzbn-sticky]');
  const syncSticky = () => {
    let pad = 0;
    stickies().forEach((bar) => {
      const after = parseInt(bar.dataset.showAfter, 10) || 0;
      let show = window.scrollY >= after;
      /* Vezano za sekciju: vidi se tek kad je dno te sekcije (anchor id) prošlo gornjih 40% ekrana */
      const past = bar.dataset.showPast ? document.getElementById(bar.dataset.showPast) : null;
      if (past) show = past.getBoundingClientRect().bottom <= window.innerHeight * 0.4;
      /* Ili od sekcije: vidi se čim vrh te sekcije (anchor id) uđe u donjih 25% ekrana, i ostaje do kraja strane */
      const from = bar.dataset.showFrom ? document.getElementById(bar.dataset.showFrom) : null;
      if (from) show = from.getBoundingClientRect().top <= window.innerHeight * 0.75;
      if (show) bar.removeAttribute('data-hidden'); else bar.setAttribute('data-hidden', '');
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      const gap = parseFloat(getComputedStyle(bar).bottom) || 0;
      pad = Math.max(pad, bar.offsetHeight + gap + 10);
    });
    if (stickies().length) document.body.style.paddingBottom = pad + 'px';
  };

  const scan = () => {
    document.querySelectorAll('.lzbn-reveal:not(.is-in), .lzbn-stagger:not(.is-in)').forEach((el) => (io ? io.observe(el) : reveal(el)));
    tickCountdowns();
    syncSticky();
  };

  window.__lzbn = { scan };
  scan();
  setInterval(tickCountdowns, 1000);
  window.addEventListener('scroll', syncSticky, { passive: true });
  window.addEventListener('resize', syncSticky);
  document.addEventListener('shopify:section:load', scan);
})();
